module.exports = __webpack_public_path__ + "static/compass-749dd4d68ea84b0df2ab6413280de2ba.svg";